module.exports = __webpack_public_path__ + "static/media/Politica.319e3cf4.pdf";